import { Handle, Position } from 'react-flow-renderer';
import { withNamespaces } from 'react-i18next';

import getStateVisuals from './stateVisuals';
import NodeHandles, { handleStyle } from './NodeHandles';

const BranchNode = ({
    data,
    t,
}) => {
    const visuals = getStateVisuals(data.state);

    return (
        <>
            <NodeHandles extra={(
                <Handle id="end" position={Position.Right} style={handleStyle} type="target" />
            )} />

            <div className="d-flex align-items-center" style={{ width: 210 }}>
                <div className="avatar-xs me-2">
                    <span className={`avatar-title rounded-circle bg-soft-${visuals.color} text-${visuals.color} font-size-16`}>
                        <i className={data.icon} />
                    </span>
                </div>

                <div>
                    <div className="font-size-12 fw-medium">{t(data.label)}</div>
                    <div className={`font-size-11 text-${visuals.color}`}>
                        {`${data.completedStages} / ${data.totalStages}`}
                        {data.hasFinding && (
                            <i className="ri-error-warning-line align-middle ms-1" />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default withNamespaces()(BranchNode);
